/**
 * Site-wide constants and configuration
 */

// =============================================================================
// VERSION INFO
// =============================================================================

const VERSION_MAJOR = 1;
const VERSION_MINOR = 0;
const VERSION_PATCH = 2;
const VERSION_PRE_RELEASE = ''; // e.g., 'alpha', 'beta', 'rc.1'
const VERSION_BUILD_METADATA = ''; // e.g., build number

export const VERSION = {
    major: VERSION_MAJOR,
    minor: VERSION_MINOR,
    patch: VERSION_PATCH,
    preRelease: VERSION_PRE_RELEASE,
    buildMetadata: VERSION_BUILD_METADATA,
    // Auto-generated version string
    get full() {
        let v = `v${VERSION_MAJOR}.${VERSION_MINOR}.${VERSION_PATCH}`;
        if (VERSION_PRE_RELEASE) v += `-${VERSION_PRE_RELEASE}`;
        if (VERSION_BUILD_METADATA) v += `+${VERSION_BUILD_METADATA}`;
        return v;
    },
    releaseDate: '2026-02-01',
    changelog: 'Minor patches in Navbar and Profile Picture upload',
};

// =============================================================================
// APP INFO
// =============================================================================

export const APP_INFO = {
    name: 'Priyo Pay Careers',
    shortName: 'Priyo Careers',
    description: 'Find your dream job with Priyo Pay',
};

// =============================================================================
// UI CONSTANTS
// =============================================================================

export const UI = {
    // Sidebar width
    sidebarWidth: 80,
    // Mobile breakpoint
    mobileBreakpoint: 'md',
    // Animation durations (ms)
    animationDuration: {
        fast: 150,
        normal: 300,
        slow: 500,
    },
};

// =============================================================================
// THEME COLORS (for reference/consistency)
// =============================================================================

export const COLORS = {
    primary: '#4f46e5',
    primaryHover: '#4338ca',
    primaryLight: '#eef2ff',
    error: '#ef4444',
    errorLight: '#fef2f2',
    success: '#10b981',
    warning: '#f59e0b',
    text: {
        primary: '#111827',
        secondary: '#6b7280',
        muted: '#9ca3af',
    },
    border: {
        default: '#d1d5db',
        light: '#e5e7eb',
    },
};

// =============================================================================
// FILE UPLOAD LIMITS
// =============================================================================

export const FILE_LIMITS = {
    resume: {
        maxSize: 10 * 1024 * 1024, // 10MB
        allowedTypes: ['application/pdf'],
        allowedExtensions: ['.pdf'],
    },
    profilePicture: {
        maxSize: 5 * 1024 * 1024, // 5MB
        allowedTypes: ['image/jpeg', 'image/png', 'image/webp'],
        allowedExtensions: ['.jpg', '.jpeg', '.png', '.webp'],
    },
};

// =============================================================================
// DEFAULT EXPORT (for backward compatibility)
// =============================================================================

const constants = {
    VERSION,
    APP_INFO,
    UI,
    COLORS,
    FILE_LIMITS,
};

export default constants;
